import AppBar from '@mui/material/AppBar';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Zoom from '@mui/material/Zoom';
import {TransitionProps} from '@mui/material/transitions';
import React, {memo, useMemo} from 'react';
import MUITypography from '../MUI-Typography';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import useSmoothScrollLock from '@/hooks/useSmoothScrollLock';

const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>
) {
    return (
        <Zoom
            in
            style={{
                transformOrigin: 'center',
                transitionDelay: '100ms'
                // transition: "1s",
            }}
            ref={ref}
            {...props}
        />
    );
});

const MUIDialog = (props: any) => {
    const {open, handleClose, fullScreen, className, children, fullWidth, maxWidth} = props;
    const scroll = useMemo(() => 'paper', []);
    const maxWidthDialog = React.useMemo(() => maxWidth, [maxWidth]);

    useSmoothScrollLock(Boolean(open));

    return fullScreen ? (
        <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition} className={className}>
            <AppBar sx={{position: 'relative'}}>
                <Toolbar>
                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        <ArrowBackIcon />
                    </IconButton>
                    <MUITypography className="mui-dialog-title" variant="h6" component="div">
                        {props.dialogTitle}
                    </MUITypography>

                    <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                        {/* <Icons.InfoIcon /> */}
                    </IconButton>
                </Toolbar>
            </AppBar>
            {children}
        </Dialog>
    ) : (
        <Dialog
            open={props.open}
            onClose={handleClose}
            TransitionComponent={Transition}
            className={className}
            fullWidth={fullWidth}
            maxWidth={maxWidthDialog}
            sx={props.sx}
        >
            {props.dialogTitle && (
                <DialogTitle id="scroll-dialog-title" className="mui-dialog-title">
                    {props.dialogTitle}
                </DialogTitle>
            )}
            {props.dialogContent && <DialogContent dividers={scroll === 'paper'}>{props.dialogContent}</DialogContent>}
            {children}
            {props.dialogActions && <DialogActions>{props.dialogActions}</DialogActions>}
        </Dialog>
    );
};
MUIDialog.displayName = 'MUIDialog';
export default memo(MUIDialog);
